import { render, staticRenderFns } from "./marketMapping.vue?vue&type=template&id=1b719f8d&scoped=true"
import script from "./marketMapping.vue?vue&type=script&lang=js"
export * from "./marketMapping.vue?vue&type=script&lang=js"
import style0 from "./marketMapping.vue?vue&type=style&index=0&id=1b719f8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b719f8d",
  null
  
)

export default component.exports